import React from 'react'
import redial from 'redial'
import DropDetailsPageAsync from './DropDetailsPage'
import { redialDropDetails } from './redial'
export const DropDetailsPage = redial.provideHooks(redialDropDetails)(() => {
  return <DropDetailsPageAsync />
})
